"use client";

import { X } from "lucide-react";
import { cn } from "@/lib/utils";
import { filterAppliedChipClass } from "./filterStyles";

interface AppliedFilterChipProps {
  label: string;
  onRemove: () => void;
  className?: string;
}

export function AppliedFilterChip({
  label,
  onRemove,
  className,
}: AppliedFilterChipProps) {
  return (
    <button
      type="button"
      onClick={onRemove}
      className={cn(filterAppliedChipClass, "shrink-0", className)}
      aria-label={`Remove ${label} filter`}>
      <span className="whitespace-nowrap">{label}</span>
      <X className="h-3.5 w-3.5 shrink-0" strokeWidth={2.5} />
    </button>
  );
}
